import { useMemo } from "react";
import type { HotelRoomRateMeta } from "@b2bportal/core-types";
import {
  getMealPlanRatesForBaseRate,
  getMealPlanRatesWithRelativePriceDiff,
  shouldShowMealPlans,
} from "./mealPlanRatesUtils";

export interface UseMealPlanRatesForBaseRateProps {
  baseRate: HotelRoomRateMeta;
  rates: HotelRoomRateMeta[];
}

/**
 * Hook that computes meal plan rates with relative price differences for the base rate.
 */
export const useMealPlanRatesForBaseRate = ({
  rates,
  baseRate,
}: UseMealPlanRatesForBaseRateProps) => {
  const mealPlanRates = useMemo(
    () => getMealPlanRatesForBaseRate(rates, baseRate),
    [rates, baseRate]
  );

  const mealPlanRatesWithPriceDiff = useMemo(
    () => getMealPlanRatesWithRelativePriceDiff(mealPlanRates, baseRate),
    [mealPlanRates, baseRate]
  );

  const showMealPlans = useMemo(
    () => shouldShowMealPlans(mealPlanRatesWithPriceDiff),
    [mealPlanRatesWithPriceDiff]
  );

  return {
    mealPlanRatesForBaseRate: mealPlanRatesWithPriceDiff,
    showMealPlans,
  };
};
